import { useMutation } from '@tanstack/react-query';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { toast } from 'sonner';
import { z } from 'zod';
import { devLogin } from '../../features/auth/api';
import { useAuth } from '../../features/auth/auth-context';
import { defaultAdminHome } from '../../features/auth/default-admin-home';
import { SupportContactBlock } from '../../shared/components/support-contact';

const searchSchema = z.object({ redirect: z.string().optional() });

export const Route = createFileRoute('/_public/login')({
  validateSearch: searchSchema,
  component: LoginPage,
});

function LoginPage() {
  const { setSession } = useAuth();
  const router = useRouter();
  const search = Route.useSearch();

  const dev = useMutation({
    mutationFn: () => devLogin(),
    onSuccess: (data) => {
      setSession({ accessToken: data.accessToken, user: data.user, adminRoles: data.adminRoles });
      router.navigate({ to: search.redirect ?? defaultAdminHome(data.adminRoles) });
    },
    onError: () => toast.error('Dev-login провалился. Бэкенд запущен?'),
  });

  const botUsername = import.meta.env.VITE_TELEGRAM_BOT_USERNAME;
  const botLink = botUsername ? `https://t.me/${botUsername}?start=admin_login` : null;

  return (
    <div className="w-full max-w-sm p-6 border rounded-lg bg-card">
      <h1 className="text-xl font-semibold mb-2">Вход в admin upme</h1>
      <p className="text-sm text-muted-foreground mb-6">
        Откройте бота в Telegram — он пришлёт кнопку для входа. Первый, кто войдёт, автоматически становится
        администратором.
      </p>
      {botLink ? (
        <Button asChild className="w-full">
          <a href={botLink} target="_blank" rel="noopener noreferrer">
            Открыть бота в Telegram
          </a>
        </Button>
      ) : (
        <p className="text-sm text-destructive">
          VITE_TELEGRAM_BOT_USERNAME не задан — обратитесь к админу инфраструктуры.
        </p>
      )}
      <SupportContactBlock className="mt-6" />
      {import.meta.env.DEV && (
        <div className="mt-6 pt-6 border-t">
          <p className="text-xs text-muted-foreground mb-2">DEV ONLY</p>
          <Button variant="outline" className="w-full" onClick={() => dev.mutate()} disabled={dev.isPending}>
            {dev.isPending ? 'Вход...' : 'Войти без Telegram (dev)'}
          </Button>
        </div>
      )}
    </div>
  );
}
